import { useEffect } from 'react'
import {
  Routes,
  Route,
  Navigate,
  useParams,
  Outlet,
  useLocation,
} from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  supportedLanguages,
  defaultLanguage,
  type SupportedLanguage,
} from '@/i18n'
import { Header } from '@/components/layout'
import { Home } from '@/pages/Home'
import { Maia } from '@/pages/Maia'
import { Bar } from '@/pages/Bar'
import { Pizza } from '@/pages/Pizza'

import { Contacts } from '@/pages/Contacts'
import { Book } from '@/pages/Book'
import { Login } from '@/pages/Login'
import { ReservedArea } from '@/pages/ReservedArea'
import { Privacy } from '@/pages/Privacy'

const HIDDEN_HEADER_PATHS = ['/area-riservata']

function LanguageWrapper() {
  const { lang } = useParams<{ lang: string }>()
  const { i18n } = useTranslation()
  const location = useLocation()
  const hideHeader = HIDDEN_HEADER_PATHS.some((path) =>
    location.pathname.endsWith(path)
  )

  useEffect(() => {
    if (lang && supportedLanguages.includes(lang as SupportedLanguage)) {
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang)
      }
    }
  }, [lang, i18n])

  // Redirect invalid language to default
  if (!lang || !supportedLanguages.includes(lang as SupportedLanguage)) {
    return <Navigate to={`/${defaultLanguage}`} replace />
  }

  return (
    <>
      {!hideHeader && <Header />}
      <Outlet />
    </>
  )
}

export function LanguageRouter() {
  return (
    <Routes>
      {/* Redirect root to default language */}
      <Route path="/" element={<Navigate to={`/${defaultLanguage}`} replace />} />

      {/* Language-prefixed routes */}
      <Route path="/:lang" element={<LanguageWrapper />}>
        <Route index element={<Home />} />
        <Route path="maia-e-tas" element={<Maia />} />
        <Route path="bar-e-tas" element={<Bar />} />
        <Route path="pizza-e-tas" element={<Pizza />} />
        <Route path="contatti" element={<Contacts />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="prenota" element={<Book />} />
        <Route path="book" element={<Book />} />
        <Route path="login" element={<Login />} />
        <Route path="area-riservata" element={<ReservedArea />} />
        <Route path="privacy" element={<Privacy />} />
      </Route>
    </Routes>
  )
}
